import type React from 'react';
import { forwardRef } from 'react';

interface ImportProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  accept?: string;
  display?: boolean;
}

const Import = forwardRef<HTMLInputElement, ImportProps>(({ onChange, accept, display = false, ...rest }, ref) => {
  return (
    <input
      ref={ref}
      type="file"
      onChange={onChange}
      style={{ display: !display ? 'none' : 'block' }}
      accept={accept}
      {...rest}
    />
  );
});

Import.displayName = 'Import';
export default Import;
